<template>
  <div v-if="contested.length" class="contest-banner">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <div class="d-flex align-items-center">
        <span class="contest-tag">CONTESTADO</span>
        <span class="ml-1">
          O colaborador contestou a rejeição de {{ contested.length }} despesa(s).
          <template v-if="reviewing">Aprove a despesa para reverter a rejeição e conclua a análise novamente.</template>
          <template v-else>Aguardando nova análise do gestor.</template>
        </span>
      </div>
      <button class="btn btn-sm btn-warning mt-50 mt-md-0" @click="$refs.modal.show()">
        <i class="fas fa-eye"></i> Ver contestação
      </button>
    </div>

    <b-modal ref="modal" title="Contestação do colaborador" size="lg" ok-only ok-title="Fechar">
      <div v-for="(item, index) in contested" :key="item.id" :class="{ 'border-top pt-1 mt-1': index > 0 }">
        <p class="mb-50">
          <strong>{{ item.expense_description }}</strong> - {{ formatCurrency(item.amount) }}
          <span class="text-muted" v-if="item.contested_at"> · contestada em {{ formatDateTime(item.contested_at) }}</span>
        </p>
        <p class="mb-50 text-danger" v-if="item.observation"><strong>Motivo da rejeição:</strong> {{ item.observation }}</p>
        <p class="mb-0"><strong>Justificativa:</strong></p>
        <div style="white-space: pre-line">{{ item.contest_justification }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { CONTEST_STATUS } from "../../utils/expenseStatus";

/**
 * Tarja exibida enquanto há contestações de despesas aguardando nova análise.
 */
export default {
  name: "ContestBanner",
  props: {
    items: { type: Array, default: () => [] },
    reviewing: { type: Boolean, default: false },
  },
  computed: {
    contested() {
      return this.items.filter((item) => Number(item.contest_status) === CONTEST_STATUS.PENDING);
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(value) || 0);
    },
    formatDateTime(value) {
      const d = new Date(value);
      return isNaN(d) ? value : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
    },
  },
};
</script>

<style scoped>
.contest-banner {
  border: 2px solid #ff9f43;
  background: rgba(255, 159, 67, 0.12);
  border-radius: 12px;
  padding: 12px 16px;
}

.contest-tag {
  background: #ff9f43;
  color: #fff;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 4px 12px;
  border-radius: 6px;
  white-space: nowrap;
}
</style>
